module.exports = __webpack_public_path__ + "static/img/task-img2.f9183be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newYearActivity/task-img2.png
// module id = OqiR
// module chunks = 2